// extracted by mini-css-extract-plugin
export default {"boardItem":"boards_boardItem__2MlRG","boardItem_details":"boards_boardItem_details__lmG+D"};